/* eslint-disable */
<template>
  <div id="app">
    <template v-if="init == 1 && params">
      <Kanban :stages="params.stages" :blocks="params.blocks" :stagesConfig="params.stages_config"
        @update-block="updateBlock">
        <div v-for="stage in params.stages" :slot="stage" :key="stage">
          <div class="item-stage">{{ stage }}</div>
        </div>
        <div v-for="block in params.blocks" :slot="block.id" :key="block.id">
          <div>
            <small>id: {{ block.id }}</small>, {{ block.title }}
          </div>
          <div class="item-descr">
            {{ block.descr }}
          </div>
        </div>
      </Kanban>
    </template>
  </div>
</template>
<script>
import Kanban from './components/KanbanBoard'
import axios from 'axios'
export default {
  name: 'App',
  components: {
    Kanban
  },
  data: () => ({
    init: 0,
    params: null
  }),
  created() {
    axios.get(API_URL + '/init/').then(response => {
      this.params = response.data
      this.init = 1
    })
      .catch(e => {
        this.errors.push(e)
      })
  },
  methods: {
    updateBlock: function (id, status) {
      axios({
        method: 'post',
        url: API_URL + '/send/',
        data: {
          'id': id,
          'status': status
        },
        headers: {
          "Content-type": "application/x-www-form-urlencoded"
        }
      })
        .then(function (response) {
          console.log('Ответ сервера успешно получен!');
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue